<template>
  <div>
    <v-data-table
        :headers="headers"
        :items="publications"
        :class="'elevation-0 ' + (this.indicatorType === 'filters' ? ' table-cursor-hand' : 'table-cursor')"
        :items-per-page="15"
        sort-by="value"
        :sort-desc="sortDesc"
        item-key="table_key"
        @click:row="clickRow"
        :footer-props="{
        itemsPerPageOptions: [15, 30, -1],
        itemsPerPageText: $t('table.itemsPerPageText')
      }"
        :loading="loading"
        :loading-text="$t('table.loading')"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-btn 
            v-if="indicatorType !== 'filters'" color="secondary" 
            class="mr-2 w-100"
            :disabled="publications.length < 1" outlined 
            :to="isAdmin?((publications.length > 0) ? `/manage/edit/publications/edit/${publications[0].id}` : ''):((publications.length > 0) ? `/publications/${publications[0].id}` : '')"
          >
            <v-icon left>mdi-eye</v-icon>
            <span class="d-none d-md-block">{{ $t('table.seeDataFromPublication') }}</span>
            <span class="d-block d-md-none">{{ $t('table.seeDataFromPublication_short') }}</span>
          </v-btn>
          <v-spacer></v-spacer>
          <VueJsonToCsv :json-data="publications" :csv-title="name_file">
            <v-btn color="secondary" class="mr-2" :disabled="publications.length < 1">
              <v-icon left>mdi-file-table-box</v-icon>
              <span class="d-none d-md-block">{{ $t('table.exportCSV') }}</span>
              <span class="d-block d-md-none">{{ $t('table.exportCSV_short') }}</span>
            </v-btn>
          </VueJsonToCsv>
          <VueJsonToExcel :data="publications" :name="name_file + '.xls'">
            <v-btn color="secondary" :disabled="publications.length < 1">
              <v-icon left>mdi-microsoft-excel</v-icon>
              <span class="d-none d-md-block">{{ $t('table.exportExcel') }}</span>
              <span class="d-block d-md-none">{{ $t('table.exportExcel_short') }}</span>
            </v-btn>
          </VueJsonToExcel>
        </v-toolbar>
      </template>
      <template v-slot:item.fetched_date="{ item }">
        <v-tooltip top v-if="item.fetched_date !== undefined">
          <template v-slot:activator="{ on }">
            <span v-on="on">{{
                timeDifference(new Date(item.fetched_date))
              }}</span>
          </template>
          <span
          >{{ new Date(item.fetched_date).toISOString().substr(0, 10) }}
            {{ new Date(item.fetched_date).toTimeString().substr(0, 8) }}</span
          >
        </v-tooltip>
      </template>
      <template v-slot:item.indicator_text="{ item }">
        <span>{{
            $t("indicators.types." + item.indicator_type) + " " + (item.year !== null ? item.year : "")
          }}
          <v-icon
            class="ml-2"
            v-if="isJsonString(item.source_info) && JSON.parse(item.source_info)['calculated'] !== undefined && JSON.parse(item.source_info)['calculated']"
            v-tooltip.top-center="$t('info.tooltip.calculated')"
            color="orange"
          >
            mdi-auto-fix
          </v-icon>
        </span>
      </template>
      <template v-slot:item.indicators="{ item }">
        <span>{{ item.indicators_text }}</span>
      </template>
      <template v-slot:item.area="{ item }">
        <span>{{
            isJsonString(item.source_info) && JSON.parse(item.source_info)['area_name'] !== undefined ? JSON.parse(item.source_info)['area_name'] : '-'
          }}</span>
      </template>
      <template v-slot:item.year="{ item }">
        <span>{{
            item.year !== null ? item.year : ""
          }}</span>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import investigatorTablesMethods from "../../../mixins/investigatorTablesMethods";
import VueJsonToCsv from "vue-json-to-csv";
import VueJsonToExcel from "vue-json-excel";
import indicator_types from "./indicator_types.json";

export default {
  mixins: [investigatorTablesMethods],
  components: {VueJsonToCsv, VueJsonToExcel},
  name: "IndicatorsTable",
  props: {
    publications: Array,
    indicatorType: String,
    filter: Object,
    headers: Array,
    loading: Boolean
  },

  data: () => ({
    indicator_types,
  }),

  methods: {
    clickRow(item) {
      if (this.indicatorType === 'filters') {
        this.$emit("indicators-publication", item);

      }
    },
    isJsonString(str) {
      try {
        var a = JSON.parse(str);
      } catch (e) {
        return false;
      }
      if(a!=null) return true;
      else return false;
    }
  },


  computed: {
    sortDesc() {
      if (this.filter !== undefined) {
        let sort = this.indicator_types.find(z => z.name === this.filter.type.value)
        return (
            this.filter.type.value !== "" && sort !== undefined && sort.sorted_desc
        );
      }
      return false;
    },

    name_file() {
      if (this.filter !== undefined) {
        let name = this.filter.type.value + "_" + this.filter.range_year;
        this.filter.author !== null ? name += '_' + this.filter.author.preferred_name.given_name.replaceAll(' ', '') +
            this.filter.author.preferred_name.family_name.replaceAll(' ', '') : '';
        this.filter.regional ? name += '_regional' : '';
        this.filter.national ? name += '_national' : '';
        this.filter.international ? name += '_international' : '';
        return name
      }
      return this.publications[0] !== undefined ? this.publications[0].title !== null ?
          this.publications[0].title.replaceAll(' ', '_') + '_indicators' : 'publication_indicators' : 'publication_indicators'
    }
  },
};
</script>

<style scoped></style>
